module.exports = __webpack_public_path__ + "img/emoji_34.38e550b8.png";